import styled, { css } from 'styled-components';

const StyleWithBorder = css`
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
  padding-bottom: 44px;
  margin-bottom: 0;
`;

export const SettingsBlockWrapper = styled.div<{ withBorder: boolean }>`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  padding: 44px 0 0;
  margin-bottom: 44px;
  ${(props) => props.withBorder && StyleWithBorder};
`;

export const BlockLabel = styled.p`
  ${(props) => props.theme.typography.label};
  color: ${(props) => props.theme.colors.muted};
  position: absolute;
  left: 0;
`;

export const CenterBlock = styled.div`
  width: 468px;
`;
